import { FormattedMessage, useIntl } from 'react-intl';

import { useSearchParameters } from '@xing-com/crate-hooks-use-search-parameters';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useSearchState } from '@xing-com/crate-jobs-hooks';

import { useSearch } from '../../../../hooks';
import { Tag } from '../applied-filters.styles';

export const LocationTag: React.FC = () => {
  const { formatMessage } = useIntl();
  const { results } = useSearch();
  const { searchQuery } = useSearchState();
  const { deleteSearchParameters } = useSearchParameters();

  const location = results?.searchQuery.body?.location;
  const locationText =
    location?.city?.name || location?.text || searchQuery.location?.text;
  const radiusText = location?.radius ?? searchQuery.location?.radius;
  const hasLocationParams =
    searchQuery.location?.text || searchQuery.location?.cityId;

  const handleOnClick = (): void => {
    deleteSearchParameters(
      [
        SEARCH_STATE_PARAMS.location,
        SEARCH_STATE_PARAMS.cityId,
        SEARCH_STATE_PARAMS.radius,
      ],
      { replace: false }
    );
  };

  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: `${formatMessage({
        id: 'JOBS_SEARCH_FILTER_LOCATION_TEXT',
      })} ${locationText}`,
    }
  );

  return hasLocationParams && locationText ? (
    <Tag onClick={handleOnClick} aria-label={ariaLabel}>
      <FormattedMessage id="JOBS_SEARCH_FILTER_LOCATION_TEXT" />
      {` ${locationText}${radiusText ? ` (${radiusText} km)` : ''}`}
    </Tag>
  ) : null;
};
